module.exports = __webpack_public_path__ + "img/0Q3C6212_FoamcoreMatted_MockedUp.6d11adc8.jpg";